if (!customElements.get('klaviyo-bis')) {
  class KlaviyoBis extends HTMLElement {
    constructor() {
      super();
    }

    handleOpenerClick(event) {
      event.preventDefault();

      this.modal.classList.add('is-open');
      this.modal.classList.toggle(
        'is-submitted',
        localStorage.getItem(`${this.variantInput.value}`),
      );

      bodyScroll.lock(this.modal);

      this.currentVariant = this.variantsData.find(
        (variant) => variant.id == this.variantInput.value,
      );

      if (!this.currentVariant) return;

      this.images.forEach((image) => {
        image.classList.toggle('hidden', this.currentVariant.id != image.id);
      });

      this.content.innerHTML = this.contentDefaultText.replace(
        '{variant}',
        `<span>${this.variantsData.length <= 1 ? this.getAttribute('data-product-title') : this.currentVariant.title}</span>`,
      );
    }

    handleSubmit(event) {
      event.preventDefault();
      // const options = {
      //   method: 'GET',
      //   mode: 'no-cors',
      //   headers: {
      //     accept: 'application/json',
      //     revision: '2024-07-15',
      //     Authorization: 'Klaviyo-API-Key pk_fc7d994cd5d940a401c0405f33666ce5f3'
      //   }
      // };

      // fetch('https://a.klaviyo.com/api/catalog-items/', options)
      //   .then(response => response.json())
      //   .then(response => console.log(response))
      //   .catch(err => console.error(err));

      const variantId = this.variantInput.value; //this.form.querySelector('input[name="variant"]').value;
      const formattedVariantId = `$shopify:::$default:::${variantId}`;
      const email = this.form.querySelector('[name="email"]').value;

      const url = 'https://a.klaviyo.com/client/back-in-stock-subscriptions';

      const data = {
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            company_id: this.getAttribute('data-company-id'),
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: email
                }
              }
            },
            channels: ["EMAIL"],
          },
          relationships: {
            variant: {
              data: {
                type: "catalog-variant",
                id: formattedVariantId
              }
            }
          }
        }
      };

      fetch(url, {
        method: 'POST',
        headers: {
          'accept': 'application/json',
          'revision': '2024-07-15',
          'content-type': 'application/json'
        },
        body: JSON.stringify(data)
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
          }

          if (response.status === 202) {
            return { status: 'Accepted' };
          }

          return response.json();
        })
        .then(result => {
          this.modal.classList.toggle('is-submitted');
          localStorage.setItem(`${this.variantInput.value}`, 'BIS');
        })
        .catch(error => {
          console.error('There was a problem with the fetch operation:', error);
        });
    }

    handleClose(event) {
      event.preventDefault();

      this.modal.classList.remove('is-open');
      bodyScroll.clear();
    }

    connectedCallback() {
      this.opener = this.querySelector('.klaviyo-bis-trigger');
      if (!this.opener) return;

      this.modal = document.querySelector(this.opener.getAttribute('href'));
      if (!this.modal) return;

      this.form = this.modal.querySelector('form');
      this.variantInput = document.querySelector(
        'main-product-selector input[name="id"]',
      );

      if (!this.form || !this.variantInput) return;

      this.images = this.modal.querySelectorAll('[js-image]');
      this.content = this.modal.querySelector('[js-content]');

      if (!this.content) return;

      this.contentDefaultText = this.content.getAttribute('data-text');

      this.variantsData = JSON.parse(
        document.querySelector('main-product-selector [data-variants-json]')
          .textContent,
      );

      if (!this.variantsData) return;

      this.opener.addEventListener('click', this.handleOpenerClick.bind(this));
      this.form.addEventListener('submit', this.handleSubmit.bind(this));

      this.modal.querySelectorAll('[href="#"]').forEach((element) => {
        element.addEventListener('click', this.handleClose.bind(this));
      });
    }
  }

  customElements.define('klaviyo-bis', KlaviyoBis);
}
